/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ShopOrderDetailDto } from '../../models/shop-order-detail-dto';

export interface ShopOrderControllerFindMyOrder$Params {

/**
 * 주문 ID
 */
  id: string;
}

export function shopOrderControllerFindMyOrder(http: HttpClient, rootUrl: string, params: ShopOrderControllerFindMyOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopOrderDetailDto>> {
  const rb = new RequestBuilder(rootUrl, shopOrderControllerFindMyOrder.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShopOrderDetailDto>;
    })
  );
}

shopOrderControllerFindMyOrder.PATH = '/api/shop-orders/my/{id}';
